export const getChecklists = (state) => state.checklists
